import { createFileRoute } from '@tanstack/react-router';
import { RelatorioVendaRelacaoVendasResumido } from '@/features/relatorio/page/venda/relacao-vendas-resumido/RelatorioVendaRelacaoVendasResumido';

export const Route = createFileRoute('/a/relatorio/venda/relacao-vendas-resumido')({
    component: RelatorioVendaRelacaoVendasResumido,
});
